import React from "react";
import "./POSBillingManagement.css";

const plans = [
  {
    name: "BASIC",
    price: "₹999 / MONTH",
    modules: [
      "HOME (READ ONLY)",
      "PROFILE",
      "DIRECTORY"
    ],
  },
  {
    name: "STANDARD",
    price: "₹1999 / MONTH",
    popular: true,
    modules: [
      "HOME",
      "COMPANY",
      "DIRECTORY",
      "PROFILE",
      "PROFESSIONAL",
      "ATTENDANCE",
      "TICKETING"
    ],
  },
  {
    name: "PREMIUM",
    price: "₹3999 / MONTH",
    modules: [
      "HOME",
      "COMPANY",
      "DIRECTORY",
      "PROFILE",
      "PROFESSIONAL",
      "ATTENDANCE",
      "PAY ROLL",
      "TICKETING",
      "ASSETS"
    ],
  },
];

const POSBillingManagement = () => {
  return (
    <div className="pos-page">
      <h1 className="pos-title">POS BILLING MANAGEMENT</h1>
      <p className="pos-subtitle">
        Choose the right subscription plan for your organization
      </p>

      <div className="plan-grid">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`plan-card ${plan.popular ? "popular" : ""}`}
          >
            {plan.popular && (
              <div className="badge">MOST POPULAR</div>
            )}

            <h2 className="plan-name">{plan.name}</h2>
            <h3 className="plan-price">{plan.price}</h3>

            <div className="module-section">
              <p className="module-title">MODULE ACCESS</p>
              <ul>
                {plan.modules.map((module, i) => (
                  <li key={i}>✔ {module}</li>
                ))}
              </ul>
            </div>

            <button className="plan-btn">
              ACTIVATE {plan.name}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default POSBillingManagement;
